<template>
  <AdminLayout><CouponsTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import CouponsTable from './CouponsTable.vue';

export default {
  name: 'AdminCoupons',
  components: { AdminLayout, CouponsTable },
};
</script>
